export default "__VITE_ASSET__DW5wc_bO__"